import { render, staticRenderFns } from "./StudioPolicy.vue?vue&type=template&id=74c10b4c"
import script from "./StudioPolicy.vue?vue&type=script&lang=ts"
export * from "./StudioPolicy.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports